import { rankings } from "@/mocks/guatrend";

function TrendTag({ trend }: { trend: number }) {
  if (trend > 0)
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-accent-500">
        <i className="ri-arrow-up-line"></i>
        {trend}
      </span>
    );
  if (trend < 0)
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-foreground-400">
        <i className="ri-arrow-down-line"></i>
        {Math.abs(trend)}
      </span>
    );
  return <span className="text-xs text-foreground-400">持平</span>;
}

export default function HotRanking() {
  return (
    <section id="hot" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-medium text-accent-500 whitespace-nowrap">REAL-TIME RANKING</p>
            <h2 className="font-display mt-2 text-2xl text-foreground-900 md:text-4xl">今日口碑热度榜 Top 10</h2>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500 whitespace-nowrap">
            <span className="inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            实时动态更新 · 全网网友好评沉淀
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {rankings.map((r) => (
            <article
              key={r.id}
              className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/50 md:gap-5"
            >
              <span
                className={`font-display flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-xl ${
                  r.id <= 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {r.id}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-semibold text-foreground-900 md:text-base">
                    {r.title}
                  </h3>
                </div>
                <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700 whitespace-nowrap">
                    {r.category}
                  </span>
                  <span className="hidden truncate text-foreground-400 sm:inline">{r.note}</span>
                </div>
                <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="heat-bar h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-500"
                    style={{ width: `${r.heat}%` }}
                  ></div>
                </div>
              </div>

              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="font-display text-lg text-primary-600 md:text-xl">{r.score}</span>
                <TrendTag trend={r.trend} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}